<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-dialog
        v-model="uploadFile"
        max-width="700px"
        scrollable
      >
        <v-card>
          <v-form
            v-model="editedItem.valid"
            ref="form"
            lazy-validation
          >
            <v-card-title>
              <span>Personal Folder Upload</span>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
              <v-autocomplete
                hint="Atleast 3 Characters required"
                :loading="loading"
                cache-items
                flat
                placeholder="Select only suggested User"
                chips
                multiple
                label="User"
                prepend-icon="notes"
                v-model="editedItem.userID"
                :items="dropUsers"
                item-text="userName"
                item-value="userID"
              >
              </v-autocomplete>

              <v-autocomplete
                hint="Atleast 3 Characters required"
                :loading="loading"
                cache-items
                flat
                placeholder="Select only suggested Document Type"
                chips
                label="Document Type"
                prepend-icon="notes"
                v-model="editedItem.departmentID"
                :items="dropDepartments"
              >
              </v-autocomplete>

              <v-autocomplete
                hint="Atleast 3 Characters required"
                :loading="loading"
                cache-items
                flat
                placeholder="Select only suggested Category"
                chips
                label="Category"
                prepend-icon="table_chart"
                v-model="editedItem.categoryID"
                :items="dropCategories"
              >
              </v-autocomplete>

              <v-text-field
                v-model="editedItem.referenceNumber"
                label="Reference Number"
                prepend-icon="select_all"
              ></v-text-field>

              <v-text-field
                v-model="editedItem.description"
                label="Description"
                prepend-icon="select_all"
              ></v-text-field>

              <v-text-field
                v-model="editedItem.displayName"
                label="Display Name"
                prepend-icon="select_all"
              ></v-text-field>

              <upload-btn
                :fileChangedCallback="fileChanged"
                title="Upload your document"
              >
                <template slot="icon-left">
                  <v-icon
                    left
                    color="white"
                  >attachment</v-icon>
                </template>
              </upload-btn>
              <div class="large-12 medium-12 small-12 cell">
                <div
                  v-for="(file, key) in uploadedFiles"
                  class="file-listing"
                >{{ file.name }}
                  <v-btn
                    v-if="!showDownLoad"
                    icon
                    @click="removeFile( key )"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>

                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="showDownLoad"
                outline
                color="primary"
                @click.native="download"
              >Download</v-btn>
              <v-btn
                outline
                color="primary"
                @click.native="save"
              >Upload</v-btn>
              <v-btn
                outline
                color="primary"
                @click="uploadFile = false"
              >Close</v-btn>

            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <!-- <v-btn
          flat
          @click="back"
        >
          <v-icon color="primary">replay</v-icon>
          &nbsp; Back &nbsp;
        </v-btn> -->
      &nbsp;
      <v-btn
        flat
        @click="openUpload"
      >
        <v-icon color="primary">cloud_upload</v-icon>
        &nbsp; Upload File
      </v-btn>

      <v-dialog
        v-model="dialog"
        max-width="700px"
      >

        <!-- <v-btn
          slot="activator"
          icon
        >
          <v-icon>add_circle_outline</v-icon>
        </v-btn> -->
        <v-card>
          <v-toolbar
            card
            dense
            color="transparent"
          >

            <v-btn
              icon
              @click.native="close"
            >
              <v-icon>reply</v-icon>
            </v-btn>

            <!-- <v-toolbar-title><h4>Details</h4></v-toolbar-title> -->
            <v-btn
              icon
              @click.native="saveAndClose"
            >
              <v-icon>library_add</v-icon>
            </v-btn>

            <v-btn
              icon
              @click.native="save"
            >
              <v-icon>save</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="add"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="deleterow"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="first"
            >
              <v-icon>first_page</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="next"
            >
              <v-icon>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="previous"
            >
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="last"
            >
              <v-icon>last_page</v-icon>
            </v-btn>
            <v-menu
              bottom
              left
            >
              <v-btn
                slot="activator"
                icon
              >
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, i) in items"
                  :key="i"
                  click
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <!-- <v-spacer></v-spacer> <v-btn color="primary" outline>Post</v-btn> -->
          </v-toolbar>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loading"
              cache-items
              flat
              placeholder="Select only suggested User"
              chips
              multiple
              label="User"
              prepend-icon="notes"
              v-model="editedItem.userID"
              :items="dropUsers"
              item-text="userName"
              item-value="userID"
            >
            </v-autocomplete>

            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loading"
              cache-items
              flat
              placeholder="Select only suggested Document Type"
              chips
              label="Document Type"
              prepend-icon="notes"
              v-model="editedItem.departmentID"
              :items="dropDepartments"
            >
            </v-autocomplete>

            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loading"
              cache-items
              flat
              placeholder="Select only suggested Category"
              chips
              label="Category"
              prepend-icon="table_chart"
              v-model="editedItem.categoryID"
              :items="dropCategories"
            >
            </v-autocomplete>

            <v-text-field
              v-model="editedItem.referenceNumber"
              label="Reference Number"
              prepend-icon="select_all"
            ></v-text-field>

            <v-text-field
              v-model="editedItem.description"
              label="Description"
              prepend-icon="select_all"
            ></v-text-field>

            <v-text-field
              v-model="editedItem.displayName"
              label="Display Name"
              prepend-icon="select_all"
            ></v-text-field>

            <upload-btn
              :fileChangedCallback="fileChanged"
              title="Upload your document"
            >
              <template slot="icon-left">
                <v-icon
                  left
                  color="white"
                >attachment</v-icon>
              </template>
            </upload-btn>
            <div class="large-12 medium-12 small-12 cell">
              <div
                v-for="(file, key) in PFuploadedFiles"
                v-model="editedItem.fileName"
                class="file-listing"
              >{{ file.name }}
                <v-btn
                  v-if="!showDownLoad"
                  icon
                  @click="removeFile( key )"
                >
                  <v-icon>close</v-icon>
                </v-btn>

              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="showDownLoad"
              outline
              color="primary"
              @click.native="download"
            >Download</v-btn>
            <v-btn
              outline
              color="primary"
              @click.native="saveAndClose"
            >Upload</v-btn>
            <v-btn
              outline
              color="primary"
              @click.native="close"
            >Close</v-btn>

          </v-card-actions>

          <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" outline @click.native="close">Cancel</v-btn>
            <v-btn color="primary darken-1" outline @click.native="save">Save</v-btn>
          </v-card-actions> -->
          <delete-confirmation-dialog
            ref="formdeleteConfirmationDialog"
            heading="Are You Sure You Want To Delete?"
            message="Are You Sure You Want To Delete This Item Permanently?"
            @onConfirm="formDeleteItem"
          >
          </delete-confirmation-dialog>

        </v-card>
      </v-dialog>
    </v-toolbar>
    <app-section-loader :status="loader"></app-section-loader>
    <v-data-table
      :headers="headers"
      :items="publicFolderGridItems"
      :search="search"
      class="elevation-1"
      default-sort="documentId:desc"
    >
      <template
        slot="items"
        slot-scope="props"
      >

        <td>{{ props.item.fileName }}</td>
        <td class="text-xs-left">{{ props.item.fileSize }}</td>
        <td class="text-xs-left">{{ props.item.referenceNumber }}</td>
        <td class="text-xs-left">{{ props.item.description }}</td>
        <td class="text-xs-left">{{ props.item.statusCode }}</td>
        <td class="text-xs-left">{{ props.item.addedByUser }}</td>
        <td class="text-xs-left">{{ props.item.addedDate | formatDate}}</td>

        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="onDeleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn
          color="primary"
          outline
          @click="initialize"
        > Record not exist.Refresh again in while time.</v-btn>
      </template>
    </v-data-table>
    <v-snackbar
      :top="y === 'top'"
      :timeout="timeout"
      v-model="snackbar"
    >
      {{ snackbarMessage }}
    </v-snackbar>
    <delete-confirmation-dialog
      ref="deleteConfirmationDialog"
      heading="Are You Sure You Want To Delete?"
      message="Are You Sure You Want To Delete This Item Permanently?"
      @onConfirm="deleteItem"
    >
    </delete-confirmation-dialog>
  </div>
</template>
<script>
//import { getStates, getCountries, getState, createState, updateState, deleteState } from '@/api/state';
import Bytes from 'bytes';
import { getFileMenu, getFile } from '@/api/file';
import { getDocuments, getPublicFolders, uploadDocuments, documentUsers, downloadFile, getDocument, getUsers, createDocuments, updateDocuments, deleteDocuments } from '@/api/document';
import UploadButton from 'vuetify-upload-button';
import GlobalMessage from '@/constant'
export default {
  components: {
    'upload-btn': UploadButton
  },
  data: () => ({
    dialog: false,
    items: [{ title: "View", id: 1 }, { title: "Download", id: 2 }],
    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    search: '',
    showDownLoad: false,
    folderName: '',
    fileSize: '',
    referenceNumber: '',
    description: '',
    addedByUserID: '',
    addedDate: '',

    loading: false,
    y: 'top',
    size: 'lg',
    view: 'grid',
    folder: false,
    uploadFile: false,
    documents: [],
    allFiles: [],
    uploadedFiles: [],
    PFuploadedFiles: [],
    dropUsers: [],
    dropDepartments: [
      { text: 'Glossary', value: 2 },
      { text: 'Abbreviation', value: 1 },
      { text: 'SOP Content', value: 3 },
      { text: 'SOP Appentix', value: 4 },
      { text: 'SOP TA Questions', value: 5 },
      { text: 'Certificate', value: 6 },
    ],
    dropCategories: [
      { text: 'Appendix', value: 1 },
      { text: 'Content', value: 2 },
      { text: 'Import', value: 3 },
      { text: 'Export', value: 4 },
      { text: 'Local', value: 5 },
    ],
    statusOptions: [
      { text: 'Active', value: 1 },
      { text: 'InActive', value: 2 }
    ],

    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    y: 'top',
    headers: [
      { text: 'Name', value: 'fileName', align: 'left' },
      { text: 'Size', value: 'fileSize', align: 'left' },
      { text: 'Reference Number', value: 'referenceNumber', align: 'left' },
      { text: 'Description', value: 'description', align: 'left' },
      { text: 'Status', value: 'statusCode', align: 'left' },
      { text: 'Updater', value: 'addedByUser', align: 'left' },
      { text: 'Update Date', value: 'addedDate', align: 'left' },
      { text: 'Actions', value: 'name', sortable: false, align: 'left' }
    ],
    editFile: {
      name: '',
      size: '',
    },
    publicFolderGridItems: [],
    gridItems: [],
    dropItems: [],
    //dropDepartments: [],
    //dropCategories: [],
    folderFfilter: false,
    editedIndex: -1,
    selectedItem: null,
    files: new FormData(),
    editedItem: {
      valid: false,
      documentAccessID: null,
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,

      displayName: '',
      wikiID: null,
      departmentID: null,
      categoryID: null,
      fileName: '',
      referenceNumber: '',
      description: '',
      addedByUserID: '',
      addedDate: new Date(),
      extension: null,
      contentType: null,
      documentType: null,
      fileData: null,
      fileSize: 0,
      uploadDate: new Date(),
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isTemp: true,
      description: '',
      uploadedFile: null,
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date(),

    },
    defaultItem: {
      valid: false,
      documentAccessID: null,
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,

      displayName: '',
      wikiID: null,
      departmentID: null,
      categoryID: null,
      fileName: '',
      referenceNumber: '',
      description: '',
      addedByUserID: '',
      addedDate: new Date(),
      extension: null,
      contentType: null,
      documentType: null,
      fileData: null,
      fileSize: 0,
      uploadDate: new Date(),
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isTemp: true,
      description: '',
      uploadedFile: null,
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date()
    },
    imageMime: ['image/jpeg', 'image/png', 'image/svg+xml'],

    folders: [

    ],

    searchItem: { action: '', Id: null, searchString: 'searchString', },
    items: [
      { title: 'Clear Items' },
      { title: 'Post' },
      { title: 'Delete' },
      { title: 'Print' }
    ],
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add Personal Folder' : 'Edit Personal Folder';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    clearSearch () {
      this.search = "";
    },

    getDept (value) {      let catt = this.dropDepartments.filter(c => c.value == value);

      return catt[0] ? catt[0].text : '';    },
    getCateg (value) {

      let catt = this.dropCategories.filter(c => c.value == value);

      return catt[0] ? catt[0].text : '';
    },
    back () {
      this.view = 'grid';
      this.folderName = '',
        this.folderFfilter = false;
      this.documents = this.allFiles;
    },
    download () {
      this.loader = true;
      downloadFile(this.editedItem.documentID)
        .then(response => {
          // const url = window.URL.createObjectURL(new Blob([response.data]));
          // const link = document.createElement('a');
          // link.href = url;
          // link.setAttribute('download', this.editedItem.fileName);
          // document.body.appendChild(link);
          // link.click();
          let blob = new Blob([response.data], { type: this.editedItem.contentType })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.editedItem.fileName
          link.click()
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    initialize () {
      this.loader = true;
      getDocuments('')
        .then(response => {
          this.gridItems = response.data;
          //   this.documents = response.data;
          this.allFiles = response.data;
          this.loader = false;
          console.log(this.gridItems);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      getPublicFolders(this.$store.state.auth.userId)
        .then(response => {
          this.publicFolderGridItems = response.data;
          //   this.documents = response.data;
          this.allFiles = response.data;
          this.loader = false;
          console.log(this.publicFolderGridItems);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      getUsers('')
        .then(response => {
          this.dropUsers = response.data;
          this.loader = false;
        })

        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    editItem (item) {
      this.editedIndex = this.documents.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      console.log(this.editedItem);
      documentUsers(this.editedItem.documentID)
        .then(response => {
          this.editedItem.userID = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      this.uploadFile = false;
    },
    close () {
      this.dialog = false;
      this.uploadedFiles = [];
      this.PFuploadedFiles = [];
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    saveAndClose () {
      this.save();
      this.close();
    },
    openUpload () {
      this.uploadedFiles = [];
      this.PFuploadedFiles = [];
      this.showDownLoad = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.uploadFile = true;
    },
    add () {
      this.uploadedFiles = [];
      this.PFuploadedFiles = [];
      this.showDownLoad = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    formDeleteItem () {
      this.$refs.formdeleteConfirmationDialog.close();
      // this.loader = true;
      let index = this.editedIndex;

      deleteDocuments(this.editedItem.documentID)
        .then(() => {
          //this.loader = false;
          //this.editedItem = null;
          this.add();
          this.gridItems.splice(index, 1);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          //this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      this.initialize();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.editedItem = item;
    },
    deleteItem () {
      this.$refs.deleteConfirmationDialog.close();
      // this.loader = true;
      let index = this.editedIndex;
      console.log(this.editedItem);
      deleteDocuments(this.editedItem)
        .then(() => {
          this.add();
          this.documents.splice(index, 1);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          //this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    save () {
      console.log(this.editedItem);
      if (this.$refs.form.validate()) {
        this.loader = true;
        let index = this.editedIndex;
        if (this.editedIndex > -1) {
          Object.assign(this.documents[this.editedIndex], this.editedItem);
          this.editedItem.modifiedByUserID = this.$store.state.auth.userId;
          this.editedItem.modifiedDate = new Date();
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          updateDocuments(this.editedItem)
            .then(response => {
              Object.assign(this.documents[index], response.data);
              this.uploadFile = false;
              this.loader = false;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        } else {
          this.editedItem.documentID = parseInt(Math.random() * 100) + 1024; // mock a id           
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          this.editedItem.statusCodeID = 1;
          uploadDocuments(this.files)
            .then(response => {
              this.editedItem.sessionID = response.data;
              updateDocuments(this.editedItem)
                .then(response => {
                  this.uploadFile = false;
                  this.documents.push(response.data);
                  this.loader = false;

                  this.editedItem = response.data;
                  let index = this.documents.map(item => item.documentID).indexOf(response.data.documentID)
                  this.editedIndex = index;
                  window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
                })
                .catch(error => {
                  this.loader = false;
                  window.getApp.$emit('APP_API_ERROR', error);
                });
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });

        }
        //this.close();
      }
    },

    toolfunction () {

      getDocument(this.searchItem)
        .then(response => {

          if (response.data.documentID != null) {

            this.editedItem = response.data;
            let index = this.documents.map(item => item.documentID).indexOf(response.data.documentID)
            this.editedIndex = index;

          }
          else {
            window.getApp.$emit('APP_API_SUCCESS', 'No More Record to View');
          }

        })
        .catch(error => {
          // this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      getPublicFolders(this.searchItem)
        .then(response => {

          if (response.data.documentID != null) {

            this.editedItem = response.data;
            let index = this.documents.map(item => item.documentID).indexOf(response.data.documentID)
            this.editedIndex = index;

          }
          else {
            window.getApp.$emit('APP_API_SUCCESS', 'No More Record to View');
          }

        })
        .catch(error => {
          // this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },

    fileChanged (file) {

      this.editedItem.fileName = file.name;
      console.log(this.editedItem.fileName);
      this.editedItem.fileSize = file.size;
      this.editedItem.contentType = file.type;
      this.files.append("file", file, file.name);
      this.uploadedFiles.push(file);
      this.PFuploadedFiles.push(file);
      // this.editedItem.uploadedFile = this.files;
      //  uploadDocuments(this.files)
      //       .then(response => {
      //        console.log(response.data);
      //       })
      //       .catch(() => {


      //       });
    },
    removeFile (key) {

      //have to remove files array which is handle at this movement 

      this.uploadedFiles.splice(key, 1);
      this.PFuploadedFiles.splice(key, 1);
    },
    isImage (file) {
      return this.imageMime.includes(file.fileType);
    },
    mimeIcons (file) {
      return this.imageMime.includes(file.fileType)
        ? 'image'
        : 'insert_drive_file';
    },
    showDetail (file) {
      this.uploadedFiles = [];
      this.PFuploadedFiles = [];
      this.editedIndex = this.documents.indexOf(file);
      this.editedItem = Object.assign({}, file);
      this.showDownLoad = true;
      this.editFile.name = this.editedItem.fileName;
      this.editFile.size = this.editedItem.fileSize;
      this.uploadedFiles.push(this.editFile);
      this.PFuploadedFiles.push(this.editFile);
      documentUsers(this.editedItem.documentID)
        .then(response => {
          this.editedItem.userID = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      this.uploadFile = true;
    },
    showFiles (item) {
      this.folderFfilter = true;
      this.folderName = item.value;
      this.documents = this.allFiles.filter(f => f.departmentID == item.value);
      this.view = 'list';
    },
    formateDate (string) {
      return string ? new Date(string).toLocaleDateString() : '';
    },


  }
};
</script>
<style lang="stylus" scoped>
.media {
  &-cotent--wrap, &-menu {
    min-width: 260px;
    border-right: 1px solid #eee;
    min-height: calc(100vh - 50px - 64px);
  }

  &-detail {
    min-width: 300px;
    border-left: 1px solid #eee;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/document/NewDocument.vue